var _class, _DataCatalogMember;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import GroupMixin from "../../ModelMixins/GroupMixin";
import ReferenceMixin from "../../ModelMixins/ReferenceMixin";
import DataCatalogGroup from "./DataCatalogGroup";
import DataCatalogItem from "./DataCatalogItem";
import DataCatalogReference from "./DataCatalogReference";

/**
 * Component that is either a {@link CatalogItem} or a {@link DataCatalogMember} and encapsulated this choosing logic.
 */
import { jsx as _jsx } from "react/jsx-runtime";
let DataCatalogMember = observer(_class = (_DataCatalogMember = class DataCatalogMember extends Component {
  render() {
    const member = ReferenceMixin.isMixedInto(this.props.member) && this.props.member.nestedTarget !== undefined ? this.props.member.nestedTarget : this.props.member;
    if (ReferenceMixin.isMixedInto(member)) {
      return /*#__PURE__*/_jsx(DataCatalogReference, {
        reference: member,
        viewState: this.props.viewState,
        terria: this.props.terria,
        onActionButtonClicked: this.props.onActionButtonClicked,
        isTopLevel: this.props.isTopLevel
      });
    } else if (GroupMixin.isMixedInto(member)) {
      return /*#__PURE__*/_jsx(DataCatalogGroup, {
        group: member,
        viewState: this.props.viewState,
        manageIsOpenLocally: this.props.manageIsOpenLocally,
        onActionButtonClicked: this.props.onActionButtonClicked,
        removable: this.props.removable,
        terria: this.props.terria,
        isTopLevel: this.props.isTopLevel
      });
    } else {
      return /*#__PURE__*/_jsx(DataCatalogItem, {
        item: member,
        viewState: this.props.viewState,
        onActionButtonClicked: this.props.onActionButtonClicked,
        removable: this.props.removable,
        terria: this.props.terria
      });
    }
  }
}, _defineProperty(_DataCatalogMember, "propTypes", {
  member: PropTypes.object.isRequired,
  viewState: PropTypes.object.isRequired,
  manageIsOpenLocally: PropTypes.bool,
  onActionButtonClicked: PropTypes.func,
  removable: PropTypes.bool,
  terria: PropTypes.object,
  isTopLevel: PropTypes.bool
}), _DataCatalogMember)) || _class;
export default DataCatalogMember;